const serviceAreas = [
    'Sydney', 
    'Newcastle', 
    'Wollongong', 
    'Albury', 
    'Wagga Wagga', 
    'Bathurst',
    'Armidale', 
    'Coffs Harbour', 
    'Dubbo', 
    'Goulburn', 
    'Lismore', 
    'Orange',
    'Port Macquarie', 
    'Tamworth', 
    'Broken Hill', 
    'Griffith', 
    'Queanbeyan', 
    'Sutherland',
    'Nowra', 
    'Maitland', 
    'Singleton', 
    'Gunnedah', 
    'Young', 
    'Tweed Heads'
];

export default serviceAreas;